import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
    ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_34_ledger_carry_forward: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Ledger carry forward",
        style: {
            backgroundColor: "#F9FAFB",
        },
        childComponents: [
            {
                componentType: LayoutTypes.GROUP,
                style: {
                    backgroundColor: "#ffffff",
                    direction: FlexDirection.COLUMN,
                    borderRadius: 12,
                    padding: 16,
                },
                childComponents: [
                    {
                        componentType: LayoutTypes.GROUP,
                        Label: "",
                        BindValue: "cont_Action",
                        style: {
                            direction: FlexDirection.ROW,
                            padding: 0,
                            margin: 0,
                            marginBottom: 8,
                        },
                        childComponents: [],
                    },
                    {
                        componentType: LayoutTypes.FORM,
                        Name: "Ledger_carry_forward",
                        TableName: "ledger_carry_forward",
                        DisplayName: "ledger_carry_forward",
                        columnNumber: "m1 t1 w3",
                        style: {
                            padding: 10,
                            backgroundColor: "#ffffff",
                            direction: FlexDirection.COLUMN,
                        },
                        childComponents: [
                            {
                                componentType: ComponentType.SELECT_DROPDOWN,
                                name: "drp_from_year",
                                label: "From year",
                                placeholder: "Select from year",
                                required: true,
                                lookupName: "get_from_accounting_year",
                                options: [],
                                Json_Attribute: "from_year",
                                IncludeNotSet: true,
                                IsVerticalView: true,
                                validation: [
                                    {
                                        rule: ValidationRule.REQUIRED,
                                        message: "From year is required",
                                    },
                                ],
                            },
                            {
                                componentType: ComponentType.SELECT_DROPDOWN,
                                name: "drp_to_year",
                                label: "To year",
                                placeholder: "Select to year",
                                required: true,
                                lookupName: "get_to_accounting_year",
                                options: [],
                                Json_Attribute: "to_year",
                                IncludeNotSet: true,
                                IsVerticalView: true,
                                validation: [
                                    {
                                        rule: ValidationRule.REQUIRED,
                                        message: "To year is required",
                                    },
                                ],
                            },
                            {
                                componentType: LayoutTypes.GROUP,
                                style: {
                                    direction: FlexDirection.ROW,
                                    padding: 16,
                                    gap: 12,
                                },
                                childComponents: [
                                    {
                                        componentType: ComponentType.BUTTON,
                                        name: "Submit",
                                        Label: "Submit",
                                        BindValue: "btn_submit",
                                        onPressAction: "save",
                                        ActionType: "Add",
                                        ScreenId: "34",
                                        style: {
                                            backgroundColor: "#22C55E",
                                            textColor: "#FFFFFF",
                                            padding: 12,
                                            borderRadius: 6,
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
];
